export const MEDIA_CDN = process.env.MEDIA_CDN;

export const FieldType = {
    TEXT: "text",
    TEXTAREA: "textarea",
    NUMBER: "number",
    INFO: "info",
    CHECKBOX: "checkbox",
    SELECT: "select",
    EMAIL: "email",
    PHONE: "phone",
    HTML: "html",
    DATE: "date",
    ASSET: "asset",
    PRICE: "price",
    REFERENCE: "reference",
};
